module.exports = __webpack_public_path__ + "img/List.42d33c07.svg";